/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import styled, { css } from 'styled-components';
import { media } from '@exo/frontend-common-style-utils';
import theme from './Modal.theme';

export const Modal = styled('div')<{ isScrollable?: boolean }>`
  & .bx--modal.is-visible {
    background-color: ${props => theme(props).overlay};
    z-index: 15;
  }

  .bx--modal-container {
    background: ${props => theme(props).background};
    box-shadow: 0.07rem 0.07rem 0.5rem ${props => props.theme.colors.inverse.base.bg},
      -0.07rem -0.07rem 0.5rem ${props => props.theme.colors.inverse.base.bg};
    max-width: 80%;
    min-width: 60%;
    width: auto;
    ${props => !props.isScrollable && 'overflow: visible;'}
  }

  ${props => media.lessThan(props, 'medium').then(css`
    .bx--modal-container {
      min-width: 100vw;
    }
  `)}

  & .bx--btn {
    font-size: 105%;
    font-weight: bold;
    line-height: 0;
    white-space: nowrap;
  }

  & .bx--modal-footer .bx--btn {
    padding-bottom: 1rem;
  }

  & .bx--modal-container .bx--modal-content {
    padding-right: 2rem;
    width: 100%;
    ${props => !props.isScrollable && 'overflow: visible;'}
  }

  & .bx--modal-header__heading {
    font: ${props => theme(props).titleFont};
  }

  & .bx--modal .bx--text-input,
  & .bx--modal .bx--dropdown,
  & .bx--modal .bx--select-input {
    background: ${props => theme(props).formElementBackground};
  }
`;
